import { Show, createEffect, onCleanup, type JSX } from 'solid-js';
import { Portal } from 'solid-js/web';

export function BottomSheet(props: {
  open: boolean;
  onClose: () => void;
  children: JSX.Element;
}) {
  createEffect(() => {
    if (!props.open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopImmediatePropagation();
        props.onClose();
      }
    }
    document.addEventListener('keydown', onKey, { capture: true });
    onCleanup(() => document.removeEventListener('keydown', onKey, { capture: true }));
  });

  return (
    <Show when={props.open}>
      <Portal>
        <div class="bottom-sheet">
          <div
            class="bottom-sheet__backdrop"
            onClick={() => props.onClose()}
            aria-hidden="true"
          />
          <div
            class="bottom-sheet__content"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >
            {props.children}
          </div>
        </div>
      </Portal>
    </Show>
  );
}
